import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { MicroCTA } from './shared/MicroCTA';
export function Chapter8() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    if (openFaq === index) {
      setOpenFaq(null);
    } else {
      setOpenFaq(index);
    }
  };
  const faqs = [{
    question: 'Hur snabbt märker man något?',
    answer: 'Många berättar om skiften inom 2–3 veckor med daglig rutin. Jag märkte små förändringar i den tidsramen. Resultat varierar.'
  }, {
    question: 'Är det ett abonnemang?',
    answer: 'Nej, varje köp är en engångsbeställning. Du bestämmer själv om och när du vill beställa igen, utan automatiska dragningar eller bindningstid.'
  }, {
    question: 'Kan jag ta det med mina läkemedel?',
    answer: 'Rådgör alltid med vården innan du kombinerar kosttillskott med läkemedel. Detta är särskilt viktigt om du tar blodförtunnande medicin, antidepressiva eller andra receptbelagda läkemedel.'
  }, {
    question: 'Är kapslarna veganska?',
    answer: 'Kapslarna är vegetariska men inte veganska då de innehåller en liten mängd gelatin. Alla aktiva ingredienser är dock växtbaserade.'
  }, {
    question: 'Hur använder jag Brainy?',
    answer: 'Ta 2 kapslar per dag, helst i samband med måltid för optimal upptagning. Många föredrar att ta dem på morgonen, men de kan tas när som helst under dagen.'
  }, {
    question: 'Finns biverkningar?',
    answer: 'Brainy innehåller naturliga ingredienser och tolereras väl av de flesta. En liten andel kan uppleva milda magbesvär. Känslighet varierar från person till person; avbryt användningen vid obehag.'
  }, {
    question: 'Garanti & leverans?',
    answer: 'Vi erbjuder 180 dagars pengarna-tillbaka-garanti. Om du inte är nöjd, kontakta vår kundtjänst för full återbetalning. Leverans sker inom 2-4 arbetsdagar och är alltid gratis.'
  }];
  return <section className="py-8 border-t border-gray-200" data-id="element-243">
      <h2 className="text-2xl font-bold mb-6" data-id="element-244">
        Frågorna jag själv hade (och svaren jag accepterade)
      </h2>
      <div className="space-y-4 my-6" data-id="element-245">
        {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-246">
            <button className="w-full px-5 py-4 text-left bg-white flex justify-between items-center" onClick={() => toggleFaq(index)} aria-expanded={openFaq === index} aria-controls={`faq-answer-${index}`} data-id="element-247">
              <span className="font-medium text-lg" data-id="element-248">{faq.question}</span>
              {openFaq === index ? <ChevronUpIcon className="h-5 w-5 text-[#2e7d32]" data-id="element-249" /> : <ChevronDownIcon className="h-5 w-5 text-[#2e7d32]" data-id="element-250" />}
            </button>
            <div id={`faq-answer-${index}`} className={`px-5 py-4 bg-gray-50 ${openFaq === index ? 'block' : 'hidden'}`} data-id="element-251">
              <p className="text-lg" data-id="element-252">{faq.answer}</p>
            </div>
          </div>)}
      </div>
      <MicroCTA text="Jag är redo – visa priset" href="#offer" className="text-right" data-id="element-253" />
    </section>;
}